module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-300.1c772d9d.woff2";